// 协议版本号
const PROTOCOL_VERSION = '1.0'

// 消息类型枚举
const MessageType = {
  C2SREQUEST: 'c2srequest',
  C2SRESPONSE: 'c2sresponse',
  S2CREQUEST: 's2crequest',
  S2CRESPONSE: 's2cresponse',
}


// 标准消息结构
/*
{
  "ver": "1.0",          // 协议版本
  "type": "request",     // 消息类型
  "reqId": "uuidv4",     // 请求ID（仅响应时存在）
  "timestamp": 1630000000, // 时间戳
  "action": "login", // 请求路径
  "data": {}          // 业务数据
}
*/

class IMClient {
  constructor(options = {}) {
    this.url = options.url || 'wss://im.gcaibang.com/ws'
    // this.url = options.url || 'ws://127.0.0.1:9080/ws'
    this.socket = null
    this.eventListeners = new Map()
    this.autoReconnect = true
    this.reconnectInterval = 5000
    this.store = null // 用于关联Vuex store
    this.pendingMessages = [] // 新增初始化语句
    this.pendingRequests = new Map()
    this.requestTimeout = 1000
    this.maxReconnectAttempts = 10
    this.reconnectCount = 0
    this.userInfo = {
      userID : '',
      userSig : ''
    }

    this.EVENT = {
        TOTAL_UNREAD_MESSAGE_COUNT_UPDATED : "unreadcount_update",
        FRIEND_LIST_UPDATED : "update_friend_list",
        CONVERSATION_LIST_UPDATED : "sesssion_list_update",
        MESSAGE_READ_BY_PEER : "message_read_by_peer",
        MESSAGE_RECEIVED : "message_received",
        MESSAGE_REVOKED : "message_revoked",
        LOGIN_SUC : "login_suc",
    }
    this.TYPES = {
      SNS_CHECK_TYPE_SINGLE : "sns_check_single",
      CONV_C2C : "c2c"
    }

    this.IsVaild = false

  }

  // 初始化方法（注入Vue实例）
  install(Vue, { store }) {
    this.store = store
    Vue.prototype.ImClient = this
    Vue.prototype.tim = this
    Vue.prototype.TIM = this
  }

  async login(obj) {
    return new Promise((resolve, reject) => {
      if (this.isConnected() || this.isConnecting) {
        return resolve('already login');
      }
      
      this.userInfo.userID = obj.userID;
      this.userInfo.userSig = obj.userSig;


        // 设置登录超时
      const timeoutId = setTimeout(() => {
            this.off(`login`, handleLoginResponse);
            reject(new Error('Login timeout'));
       }, this.requestTimeout);
  
      // 添加登录响应监听器
      const handleLoginResponse = (message) => {
        this.off(`login`, handleLoginResponse);
        clearTimeout(timeoutId);
        if(message == "suc") {
          setTimeout(()=>{
            this.request("get_unreadcount", {})
          })
          setTimeout(()=>{
            this.dispatch(this.EVENT.LOGIN_SUC)
            this.IsVaild = true
          })
          resolve(message);
        } else {
          reject(new Error(message || 'Login failed'));
        }
      };
  
      try {
        this.isConnecting = true;
        
        // 注册登录响应监听
        this.on(`login`, handleLoginResponse);
  
        // 清理旧连接
        if (this.socket) {
          this._cleanup();
        }
  
        // 创建新连接
        this.socket = new WebSocket(`${this.url}?user=${this.userInfo.userID}&pwd=${this.userInfo.userSig}`);
        
        // 设置连接处理器
        this._setupConnectionHandlers()
          .then(() => {
            this.dispatch('connect');
            this._processPendingMessages();
            this.reconnectCount = 0;
          })
          .catch(reject);
  
      } catch (error) {
        this.dispatch('error', error);
        reject(error);
      } finally {
        this.isConnecting = false;
      }
    });
  }


  // 私有方法：设置连接处理器
  _setupConnectionHandlers() {
    return new Promise((resolve, reject) => {
      this.socket.onopen = () => {
        console.log('WebSocket connection established')
        resolve()
      }

      this.socket.onclose = (event) => {
        console.log(`WebSocket closed: ${event.reason}`)
        this.dispatch('disconnect', event)
        if(event.reason != "Logged in from another location"){
          this._handleReconnection()
        }
      }

      this.socket.onerror = (error) => {
        console.log('WebSocket error:', error)
        reject(error)
      }

      this.socket.onmessage = (event) => {
        this._handleMessage(event)
      }
    })
  }

  // 消息处理器增强
  _handleMessage(event) {
    try {
      const message = JSON.parse(event.data)
      this._validateProtocol(message)

      switch (message.type) {
        case MessageType.C2SRESPONSE:
          this._handleResponse(message)
          break
        case MessageType.S2CREQUEST:
          this._handlePush(message)
          break
        case MessageType.HEARTBEAT:
          this._handleHeartbeat(message)
          break
        default:
          this.dispatch('protocol_error', {
            type: 'UNKNOWN_MESSAGE_TYPE',
            message
          })
      }
    } catch (error) {
      this.dispatch('parse_error', { error, raw: event.data })
    }
  }

  // 处理响应消息
  _handleResponse(message) {
    const request = this.pendingRequests.get(message.reqId)
    if (!request) {
      this.dispatch('orphan_response', message)
      return
    }

    clearTimeout(request.timer)
    this.pendingRequests.delete(message.reqId)

    if (message.status >= 200 && message.status < 300) {
      request.resolve(message.data)
    } else {
      const error = new Error(message?.error || 'Request failed')
      error.code = message.status
      request.reject(error)
    }
  }

  // 处理推送消息
  _handlePush(message) {
    // 按路径分发事件：如 dispatch(`push:${message.path}`)
    this.dispatch(`${message.action}`, message.data)
  }

  // 协议验证
  _validateProtocol(message) {
    const requiredFields = [ 'type', 'reqId', 'timestamp']
    if (!requiredFields.every(field => field in message)) {
      throw new Error('Invalid protocol format')
    }
  }

  // 生成请求ID（UUID v4简化版）
  _generateRequestId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }

  // 处理请求超时
  _handleTimeout(reqId) {
    const request = this.pendingRequests.get(reqId)
    if (request) {
      request.reject(new Error('Request timeout'))
      this.pendingRequests.delete(reqId)
      this.dispatch('request_timeout', { reqId })
    }
  }

  // 重连处理
  _handleReconnection() {
    if (this.reconnectCount < this.maxReconnectAttempts) {
      const delay = Math.min(1000 * Math.pow(2, this.reconnectCount), 30000)
      this.reconnectTimer = setTimeout(() => {
        this.reconnectCount++
        console.log(`Reconnecting (attempt ${this.reconnectCount})...`)
        this.login(this.userInfo)
      }, delay)
    } else {
      this.dispatch('connection_lost')
    }
  }

  // 处理待发送消息
  _processPendingMessages() {
    if (!Array.isArray(this.pendingMessages)) {
      this.pendingMessages = []
    }
    while (this.pendingMessages.length > 0) {
      const { type, payload } = this.pendingMessages.shift()
      this.send(type, payload)
    }
  }

  // 连接状态检查
  isConnected() {
    return this.socket?.readyState === WebSocket.OPEN
  }

  // 清理资源
  _cleanup() {
    if (this.socket) {
      this.socket.onopen = null
      this.socket.onclose = null
      this.socket.onerror = null
      this.socket.onmessage = null
      this.socket.close()
      this.socket = null
    }
    clearTimeout(this.reconnectTimer)
  }

  // 增强版请求方法
  request(path, payload = {}) {
    return new Promise((resolve, reject) => {
      // 确保Map实例有效
      if (!this.pendingRequests || !(this.pendingRequests instanceof Map)) {
        console.warn('pendingRequests is invalid, resetting...')
        this.pendingRequests = new Map()
      }

      const reqId = this._generateRequestId()
      const date = new Date()

      // 构建协议消息
      const message = {
        ver: PROTOCOL_VERSION,
        type: MessageType.C2SREQUEST,
        reqId: reqId,
        timestamp:date.toLocaleString(),
        action:path,
        data:payload
      }


      // 注册请求回调
      this.pendingRequests.set(reqId, {
        resolve,
        reject,
        timer: setTimeout(() => {
          this._handleTimeout(reqId)
        }, this.requestTimeout)
      })

      // 发送请求
      this.send(message)
    })
  }

  // 增强版发送方法
  send(payload) {
    if (this.isConnected()) {
      this._safeSend(payload)
    } else {
      if (!Array.isArray(this.pendingMessages)) {
        this.pendingMessages = []
      }
      this.pendingMessages.push(payload)
      if (!this.isConnecting) {
        throw new Error('send err, not connect')
      }
    }
  }

  // 安全发送
  _safeSend(data) {
    try {
      this.socket.send(JSON.stringify(data))
    } catch (error) {
      this.dispatch('error', {
        type: 'SEND_ERROR',
        error,
        data
      })
    }
  }

 
  // 事件系统
  on(event, callback) {
    if (!this.eventListeners.has(event)) {
      this.eventListeners.set(event, [])
    }
    this.eventListeners.get(event).push(callback)
  }

  off(event, callback) {
    const listeners = this.eventListeners.get(event)
    if (listeners) {
      this.eventListeners.set(
        event,
        listeners.filter(fn => fn !== callback))
    }
  }

  dispatch(event, payload) {
    // 触发Vuex mutations
    if (this.store && this.store._actions[`im/${event}`]) {
      this.store.dispatch(`im/${event}`, payload)
    }

    // 触发组件监听器
    const listeners = this.eventListeners.get(event) || []
    listeners.forEach(callback => callback(payload))
  }


  // 断开连接
  disconnect() {
    this.autoReconnect = false
    this.socket.close()
  }

  createCustomMessage(payload) {
    return payload
  }

  sendMessage(payload) {
    return this.request("send_message", payload)
  }

  getConversationList(payload){
    let userIds = {
      userNames:[]
    }
    if(payload){
      payload.forEach(item => {userIds.userNames.push(item.slice(3))})
    }
    return this.request("get_sessions",userIds)
  }

  setMessageRead(payload) {
    payload.conversationID = payload.conversationID.slice(3)
    return this.request("mark_message_read", payload)
  }

  getUserProfile(payload) {
    return this.request("get_users_profile", payload)
  }

  getMessageList(payload) {
    let obj = {
      with_user:payload.conversationID.slice(3),
      messageID:payload.nextReqMessageID ?  payload.nextReqMessageID : '', 
      page_size:payload.count
    }
    return this.request("get_history", obj)
  } 


  getFriendList() {
    return
  }

  checkFriend(payload) {
    return new Promise((resolve, reject) => {
      let successUserIDList = []
      let failureUserIDList = []
      for(var id in payload.userIDList){
        successUserIDList.push({relation: "type_is_not"})
      }
      resolve({data:{successUserIDList,failureUserIDList}});
    })
  }

  addFriend(payload) {
    return new Promise((resolve, reject) => {
      resolve({});
    })
  }

  logout() {
    this.disconnect()
    this._cleanup()
  }

  searchUser(payload) {
    return this.request("search_user_list", payload)
  }

  revokeMessage(payload) {
    return this.request("message_revoke", payload)
  }


}

export default new IMClient()